import React from 'react';
import { CheckFillCircle, RadioIcon } from 'src/components/icons';

export type Props = {
  status?: boolean;
  checked?: boolean;
  value?: string;
  onChange?: (value: string | number) => void;
  label?: React.ReactNode;
  defaultAnswer?: string[] | null;
};

const RadioWithStatus: React.FC<Props> = ({
  status,
  value,
  checked,
  onChange,
  label,
  defaultAnswer = [],
}) => {
  return (
    <span
      className={`radio status ${checked ? 'check' : ''} ${
        status === undefined ? '' : `${status}`
      }`}
      onClick={() => onChange?.(value!)}
    >
      <RadioIcon /> {label}{' '}
      {defaultAnswer?.includes(value || '') && <CheckFillCircle />}
    </span>
  );
};

export default RadioWithStatus;
